var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.69 4.29a1.14 1.14 0 00-1.526.007 1.05 1.05 0 00-.118.131l-6.925 9.195-3.167-4.205c-.341-.454-1.014-.565-1.503-.249a.986.986 0 00-.234 1.444l3.572 4.743c.514.682 1.528.849 2.263.372.156-.101.292-.227.401-.372l7.33-9.732a.986.986 0 00-.093-1.335z",
    fill: "#36C480",
    fillRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckmark);
export default ForwardRef;